module.exports = __webpack_public_path__ + "img/bg4.2ed4593b.png";